// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","dotsSpinner":"Loader_dotsSpinner__F+S3Q","dot":"Loader_dot__7Nm3P","pulse":"Loader_pulse__P63UF","loadingText":"Loader_loadingText__URtw4"};